// import React, { useState } from "react";
// import "./SearchEngine.css";

// const SearchEngine = () => {
//   const [query, setQuery] = useState("");
//   const [response, setResponse] = useState("");
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!query) return;

//     setIsSubmitted(true);

//     try {
//       const res = await fetch("https://api.gft.eagleqms.com/api/chat", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ query }),
//       });
//       const data = await res.json();
//       setResponse(data.response || "No response from the chatbot.");
//     } catch (error) {
//       setResponse("Error fetching response from the chatbot.");
//     }
//   };

//   return (
//     <div className="div-search-engine">
//     <div className="search-engine-container">
//       {/* Heading and Input Box */}
//       <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
//         <h1 className={`company-name ${isSubmitted ? "slide-left" : ""}`}>
//           EagleQMS
//         </h1>
//         <form onSubmit={handleSearch} className="search-form">
//           <input
//             type="text"
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             className="search-input"
//             placeholder="Ask me anything..."
//           />
//         </form>
//       </div>

//       {/* Response Display Area */}
//       {isSubmitted && (
//         <div className="response-container">
//           <div className="query-display">
//             <strong>You:</strong> {query}
//           </div>
//           <div className="response-display">
//             <strong>EagleQMS:</strong> {response}
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// };

// export default SearchEngine;

// import React, { useState } from "react";
// import "./SearchEngine.css";

// const SearchEngine = () => {
//   const [query, setQuery] = useState("");
//   const [chatHistory, setChatHistory] = useState([]);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!query) return;

//     setIsSubmitted(true);

//     try {
//       const res = await fetch("http://localhost:5800/api/chat", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ query }),
//       });
//       const data = await res.json();
//       const response = data.response || "No response from the chatbot.";

//       // Add the new query and response to the chat history
//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         { query, response },
//       ]);

//       // Clear the input box
//       setQuery("");
//     } catch (error) {
//       const errorMessage = "Error fetching response from the chatbot.";
//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         { query, response: errorMessage },
//       ]);
//     }
//   };

//   return (
//     <div className="div-search-engine">
//       <div className="search-engine-container">
//         {/* Heading and Input Box */}
//         <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
//           <h1 className={`company-name ${isSubmitted ? "slide-left" : ""}`}>
//             EagleQMS
//           </h1>
//           <form onSubmit={handleSearch} className="search-form">
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               className="search-input"
//               placeholder="Ask me anything..."
//             />
//           </form>
//         </div>

//         {/* Chat History Display Area */}
//         {isSubmitted && (
//           <div className="response-container">
//             {chatHistory.map((chat, index) => (
//               <div key={index} className="chat-item">
//                 <div className="query-display">
//                   <strong>You:</strong> {chat.query}
//                 </div>
//                 <div className="response-display">
//                   <strong>EagleQMS:</strong> {chat.response}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchEngine;

// import React, { useState } from "react";
// import "./SearchEngine.css";

// const SearchEngine = () => {
//   const [query, setQuery] = useState("");
//   const [chatHistory, setChatHistory] = useState([]);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   // Mock user and employee details (replace with actual data)
//   const userDetails = { id: "123", name: "Company Name" };
//   const employeeDetails = { id: "456", name: "Employee Name" };

//   // Parse the chatbot response
//   const parseResponse = (text, references = []) => {
//     const lines = text.split("\n");
//     const parsedElements = [];

//     lines.forEach((line, index) => {
//       if (line.startsWith("## ")) {
//         // Heading
//         parsedElements.push(
//           <h2 key={`heading-${index}`} className="heading">
//             {line.replace("## ", "")}
//           </h2>
//         );
//       } else if (line.startsWith("**") && line.endsWith("**")) {
//         // Subheading
//         parsedElements.push(
//           <p key={`subheading-${index}`} className="subheading">
//             <strong>{line.replace(/\*\*/g, "")}</strong>
//           </p>
//         );
//       } else if (line.startsWith("* ")) {
//         // Bullet point with potential nested bold text
//         const nestedBoldText = line
//           .replace("* ", "")
//           .split("**")
//           .map((part, i) =>
//             i % 2 === 1 ? (
//               <strong key={`bold-${index}-${i}`}>{part}</strong>
//             ) : (
//               part
//             )
//           );
//         parsedElements.push(
//           <li key={`bullet-${index}`} className="bullet-point">
//             {nestedBoldText}
//           </li>
//         );
//       } else if (line.includes("Download Form")) {
//         // Download button
//         const match = line.match(/<a href="(.*?)" download>(.*?)<\/a>/);
//         if (match) {
//           const url = match[1];
//           const buttonText = match[2];
//           parsedElements.push(
//             <div key={`download-${index}`} className="form-response">
//               <a
//                 href={url}
//                 download
//                 className="download-button"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 {buttonText}
//               </a>
//             </div>
//           );
//         } else {
//           parsedElements.push(
//             <p key={`line-${index}`} className="paragraph">
//               {line}
//             </p>
//           );
//         }
//       } else {
//         // Regular paragraph with potential nested bold text
//         const nestedBoldText = line
//           .split("**")
//           .map((part, i) =>
//             i % 2 === 1 ? (
//               <strong key={`bold-${index}-${i}`}>{part}</strong>
//             ) : (
//               part
//             )
//           );
//         parsedElements.push(
//           <p key={`paragraph-${index}`} className="paragraph">
//             {nestedBoldText}
//           </p>
//         );
//       }
//     });

//     // Append references if available
//     if (references.length > 0) {
//       parsedElements.push(
//         <div key="references" className="references">
//           <h4>References:</h4>
//           {references.map((ref, i) => (
//             <button
//               key={`reference-${i}`}
//               onClick={() => window.open(ref.link, "_blank")}
//               className="reference-button"
//             >
//               {ref.title}
//             </button>
//           ))}
//         </div>
//       );
//     }

//     return parsedElements;
//   };

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!query) return;

//     setIsSubmitted(true);
//     setIsLoading(true);

//     try {
//       const res = await fetch("http://localhost:5800/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           message: query,
//           employeeId: employeeDetails.id,
//           employeeName: employeeDetails.name,
//           companyId: userDetails.id,
//         }),
//       });
//       const data = await res.json();
//       setIsLoading(false);

//       // Parse the response
//       const parsedResponse = parseResponse(data.response, data.references);

//       // Add the new query and response to the chat history
//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         { query, response: parsedResponse, formUrl: data.form_url },
//       ]);

//       // Clear the input box
//       setQuery("");
//     } catch (error) {
//       setIsLoading(false);
//       const errorMessage = "Sorry, there was an error!";
//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         { query, response: errorMessage },
//       ]);
//     }
//   };

//   return (
//     <div className="div-search-engine">
//       <div className="search-engine-container">
//         {/* Heading and Input Box */}
//         <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
//           <h1 className={`company-name ${isSubmitted ? "slide-left" : ""}`}>
//             EagleQMS
//           </h1>
//           <form onSubmit={handleSearch} className="search-form">
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               className="search-input"
//               placeholder="Ask me anything..."
//               disabled={isLoading}
//             />
//           </form>
//         </div>

//         {/* Chat History Display Area */}
//         {isSubmitted && (
//           <div className="response-container">
//             {chatHistory.map((chat, index) => (
//               <div key={index} className="chat-item">
//                 <div className="query-display">
//                   <strong>You:</strong> {chat.query}
//                 </div>
//                 <div className="response-display">
//                   <strong>EagleQMS:</strong> {chat.response}
//                   {chat.formUrl && (
//                     <div className="form-response">
//                       <a
//                         href={chat.formUrl}
//                         download
//                         className="download-button"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         Download Form
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}
//             {isLoading && <div className="loading">Loading...</div>}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchEngine;

// the below code is working for /chat endpoint
// import React, { useState, useEffect } from "react";
// import "./SearchEngine.css";

// const SearchEngine = () => {
//   const [query, setQuery] = useState("");
//   const [chatHistory, setChatHistory] = useState([]);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   // Mock user and employee details (replace with actual data)
//   const userDetails = { id: "123", name: "Company Name" };
//   const employeeDetails = { id: "456", name: "Employee Name" };

//   // Load chat history from localStorage on component mount
//   useEffect(() => {
//     const savedChatHistory = localStorage.getItem("chatHistory");
//     if (savedChatHistory) {
//       setChatHistory(JSON.parse(savedChatHistory));
//     }
//   }, []);

//   // Save chat history to localStorage whenever it changes
//   useEffect(() => {
//     localStorage.setItem("chatHistory", JSON.stringify(chatHistory));
//   }, [chatHistory]);

//   // Parse the chatbot response
//   const parseResponse = (text, references = []) => {
//     const lines = text.split("\n");
//     const parsedElements = [];

//     lines.forEach((line, index) => {
//       if (line.startsWith("## ")) {
//         // Heading
//         parsedElements.push(
//           <h2 key={`heading-${index}`} className="heading">
//             {line.replace("## ", "")}
//           </h2>
//         );
//       } else if (line.startsWith("**") && line.endsWith("**")) {
//         // Subheading
//         parsedElements.push(
//           <p key={`subheading-${index}`} className="subheading">
//             <strong>{line.replace(/\*\*/g, "")}</strong>
//           </p>
//         );
//       } else if (line.startsWith("* ")) {
//         // Bullet point with potential nested bold text
//         const nestedBoldText = line
//           .replace("* ", "")
//           .split("**")
//           .map((part, i) =>
//             i % 2 === 1 ? (
//               <strong key={`bold-${index}-${i}`}>{part}</strong>
//             ) : (
//               part
//             )
//           );
//         parsedElements.push(
//           <li key={`bullet-${index}`} className="bullet-point">
//             {nestedBoldText}
//           </li>
//         );
//       } else if (line.includes("<a href=")) {
//         // Download button
//         const match = line.match(/<a href="(.*?)" download>(.*?)<\/a>/);
//         if (match) {
//           const url = match[1];
//           const buttonText = match[2];
//           parsedElements.push(
//             <div key={`download-${index}`} className="form-response">
//               <a
//                 href={url}
//                 download
//                 className="download-button"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 {buttonText}
//               </a>
//             </div>
//           );
//         }
//       } else {
//         // Regular paragraph with potential nested bold text
//         const nestedBoldText = line
//           .split("**")
//           .map((part, i) =>
//             i % 2 === 1 ? (
//               <strong key={`bold-${index}-${i}`}>{part}</strong>
//             ) : (
//               part
//             )
//           );
//         parsedElements.push(
//           <p key={`paragraph-${index}`} className="paragraph">
//             {nestedBoldText}
//           </p>
//         );
//       }
//     });

//     // Append references if available
//     if (references.length > 0) {
//       parsedElements.push(
//         <div key="references" className="references">
//           <h4>References:</h4>
//           {references.map((ref, i) => (
//             <button
//               key={`reference-${i}`}
//               onClick={() => window.open(ref.link, "_blank")}
//               className="reference-button"
//             >
//               {ref.title}
//             </button>
//           ))}
//         </div>
//       );
//     }

//     return parsedElements;
//   };

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!query) return;

//     setIsSubmitted(true);
//     setIsLoading(true);

//     try {
//       const res = await fetch("http://localhost:5800/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           message: query,
//           employeeId: employeeDetails.id,
//           employeeName: employeeDetails.name,
//           companyId: userDetails.id,
//         }),
//       });
//       const data = await res.json();
//       setIsLoading(false);

//       // Parse the response
//       const parsedResponse = parseResponse(data.response, data.references);

//       // Add the new query and response to the chat history
//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         { query, response: parsedResponse, formUrl: data.form_url },
//       ]);

//       // Clear the input box
//       setQuery("");
//     } catch (error) {
//       setIsLoading(false);
//       const errorMessage = "Sorry, there was an error!";
//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         { query, response: errorMessage },
//       ]);
//     }
//   };

//   return (
//     <div className="div-search-engine">
//       <div className="search-engine-container">
//         {/* Heading and Input Box */}
//         <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
//           <h1 className={`company-name ${isSubmitted ? "slide-left" : ""}`}>
//             EagleQMS
//           </h1>
//           <form onSubmit={handleSearch} className="search-form">
//             <div className="choose-model">
//               <select
//                 className="model-select"
//                 name="model"
//                 id="model"
//                 onChange={(e) => console.log(e.target.value)}
//               >
//                 <option value="model1">Internal</option>
//                 <option value="model2">Advance</option>
//               </select>
//             </div>
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               className="search-input"
//               placeholder="Ask me anything..."
//               disabled={isLoading}
//             />
//             <div>
//               <button type="submit" className="search-button">
//                 Search
//               </button>
//             </div>
//           </form>
//         </div>

//         {/* Chat History Display Area */}
//         {isSubmitted && (
//           <div className="response-container">
//             {chatHistory.map((chat, index) => (
//               <div key={index} className="chat-item">
//                 <div className="query-display">
//                   <strong>You:</strong> {chat.query}
//                 </div>
//                 <div className="response-display">
//                   <strong>EagleQMS:</strong> {chat.response}
//                   {chat.formUrl && (
//                     <div className="form-response">
//                       <a
//                         href={chat.formUrl}
//                         download
//                         className="download-button"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         Download Form
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}
//             {isLoading && <div className="loading">Loading...</div>}
//             <div className="remove-button">
//               <button
//                 onClick={() => {
//                   setChatHistory([]); // Clear chat history from state
//                   localStorage.removeItem("chatHistory"); // Clear chat history from localStorage
//                 }}
//                 className="clear-chat-button"
//               >
//                 Clear Chat History
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchEngine;

// the below code is working for /chat endpoint and /advance-chat endpoint
// import React, { useState, useEffect, useRef } from "react";
// import "./SearchEngine.css";
// const apiUrl = process.env.REACT_APP_API_URL;

// const SearchEngine = () => {
//   const [query, setQuery] = useState("");
//   const [chatHistory, setChatHistory] = useState([]);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedModel, setSelectedModel] = useState("internal"); // Default to internal model

//   // Mock user and employee details (replace with actual data)
//   const userDetails = { id: "123", name: "Company Name" };
//   const employeeDetails = { id: "456", name: "Employee Name" };

//   // Add a ref for the response container
//   const responseContainerRef = useRef(null);

//   // Add scroll effect
//   useEffect(() => {
//     if (responseContainerRef.current) {
//       responseContainerRef.current.scrollTo({
//         top: responseContainerRef.current.scrollHeight,
//         behavior: "smooth",
//       });
//     }
//   }, [chatHistory, isLoading]);

//   // Load chat history from localStorage on component mount
//   // useEffect(() => {
//   //   const savedChatHistory = localStorage.getItem("chatHistory");
//   //   if (savedChatHistory) {
//   //     setChatHistory(JSON.parse(savedChatHistory));
//   //   }
//   // }, []);
//   // useEffect(() => {
//   //   const savedChatHistory = localStorage.getItem("chatHistory");
//   //   if (savedChatHistory) {
//   //     const parsedHistory = JSON.parse(savedChatHistory);
//   //     const migratedHistory = parsedHistory.map((item) => ({
//   //       id: item.id || crypto.randomUUID(),
//   //       query: item.query,
//   //       responseText: item.responseText || "", // Handle legacy items
//   //       references: item.references || [],
//   //       formUrl: item.formUrl || "",
//   //     }));
//   //     setChatHistory(migratedHistory);
//   //   }
//   // }, []);

//   // // Save chat history to localStorage whenever it changes
//   // useEffect(() => {
//   //   localStorage.setItem("chatHistory", JSON.stringify(chatHistory));
//   // }, [chatHistory]);

//   // Clear storage on page load and before unload
//   useEffect(() => {
//     // Clear immediately when component mounts
//     localStorage.removeItem("chatHistory");

//     // Clear when user leaves the page
//     const handleBeforeUnload = () => {
//       localStorage.removeItem("chatHistory");
//     };

//     window.addEventListener("beforeunload", handleBeforeUnload);

//     return () => {
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, []); // Empty dependency array = runs only once on mount

//   // Parse the chatbot response
//   const parseResponse = (text, references = []) => {
//     try {
//       if (!text || text === "No response from the chatbot.") {
//         return <div className="no-response">No response received</div>;
//       }
//       if (typeof text !== "string") return "Invalid response format.";
//       const lines = text.split("\n").filter((line) => line.trim() !== "");
//       const parsedElements = [];

//       lines.forEach((line, index) => {
//         if (line.startsWith("## ")) {
//           parsedElements.push(
//             <h2 key={`heading-${index}`} className="heading">
//               {line.replace("## ", "")}
//             </h2>
//           );
//         } else if (line.startsWith("**") && line.endsWith("**")) {
//           parsedElements.push(
//             <p key={`subheading-${index}`} className="subheading">
//               <strong>{line.replace(/\*\*/g, "")}</strong>
//             </p>
//           );
//         } else if (line.startsWith("* ")) {
//           const nestedBoldText = line
//             .replace("* ", "")
//             .split("**")
//             .map((part, i) =>
//               i % 2 === 1 ? (
//                 <strong key={`bold-${index}-${i}`}>{part}</strong>
//               ) : (
//                 part
//               )
//             );
//           parsedElements.push(
//             <li key={`bullet-${index}`} className="bullet-point">
//               {nestedBoldText}
//             </li>
//           );
//         } else if (line.includes("<a href=")) {
//           const match = line.match(/<a href="(.*?)" download>(.*?)<\/a>/);
//           if (match) {
//             const url = match[1];
//             const buttonText = match[2];
//             parsedElements.push(
//               <div key={`download-${index}`} className="form-response">
//                 <a
//                   href={url}
//                   download
//                   className="download-button"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   {buttonText}
//                 </a>
//               </div>
//             );
//           }
//         } else {
//           const nestedBoldText = line
//             .split("**")
//             .map((part, i) =>
//               i % 2 === 1 ? (
//                 <strong key={`bold-${index}-${i}`}>{part}</strong>
//               ) : (
//                 part
//               )
//             );
//           parsedElements.push(
//             <p key={`paragraph-${index}`} className="paragraph">
//               {nestedBoldText}
//             </p>
//           );
//         }
//       });

//       if (references.length > 0) {
//         const validReferences = references.filter(
//           (ref) => ref.link && ref.title
//         );

// if (references.length > 0) {
//   parsedElements.push(
//     <div key="references" className="references">
//       <h4>References:</h4>
//       {references.map((ref, i) => (
//         <button
//           key={`reference-${i}`}
//           onClick={() => window.open(ref.link, "_blank")}
//           className="reference-button"
//         >
//           {ref.title}
//         </button>
//       ))}
//     </div>
//   );
// }
//       }

//       return parsedElements;
//     } catch (error) {
//       console.error("Error parsing response:", error);
//       return "Could not parse chatbot response.";
//     }
//   };

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!query || isLoading) return;

//     setIsSubmitted(true);
//     setIsLoading(true);

//     const apiUrlEndpoint =
//       selectedModel === "internal" ? "/chat" : "/advance-chat";

//     try {
//       const res = await fetch(`${apiUrl}${apiUrlEndpoint}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           message: query,
//           employeeId: employeeDetails.id,
//           employeeName: employeeDetails.name,
//           companyId: userDetails.id,
//         }),
//       });
//       if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
//       const data = await res.json();
//       // Validate response structure
//       if (!data.response && !data.form_url) {
//         throw new Error("Invalid API response structure");
//       }
//       setIsLoading(false);

//       const parsedResponse = parseResponse(data.response, data.references);

//       // setChatHistory((prevHistory) => [
//       //   ...prevHistory,
//       //   {
//       //     id: crypto.randomUUID(),
//       //     query,
//       //     response: parsedResponse,
//       //     formUrl: data.form_url,
//       //   },
//       // ]);
//       // setChatHistory((prevHistory) => [
//       //   ...prevHistory,
//       //   {
//       //     id: crypto.randomUUID(),
//       //     query,
//       //     responseText: data.response, // Store raw text
//       //     references: data.references || [], // Store raw references
//       //     formUrl: data.form_url,
//       //   },
//       // ]);
//       setChatHistory((prev) => [
//         ...prev,
//         {
//           id: crypto.randomUUID(),
//           query,
//           responseText: data.response,
//           references: data.references || [],
//           formUrl: data.form_url,
//         },
//       ]);

//       setQuery("");
//     } catch (error) {
//       setIsLoading(false);
//       const errorMessage = error.message.includes("Failed to fetch")
//         ? "Network error - please check your connection"
//         : "Sorry, there was an error processing your request";

//       setChatHistory((prevHistory) => [
//         ...prevHistory,
//         {
//           id: crypto.randomUUID(),
//           query,
//           responseText: errorMessage, // Changed from 'response'
//           references: [],
//           formUrl: null,
//         },
//       ]);
//     } finally {
//       setIsLoading(false); // Add this line
//     }
//   };

//   return (
//     <div className="div-search-engine">
//       <div className="search-engine-container">
//         <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
//           {/* <h1 className={`company-name ${isSubmitted ? "slide-left" : ""}`}>
//             EagleQMS
//           </h1> */}
//           <form onSubmit={handleSearch} className="search-form">
//             <div className="choose-model">
//               <select
//                 className="model-select"
//                 name="model"
//                 id="model"
//                 aria-label="Select chatbot model"
//                 onChange={(e) => setSelectedModel(e.target.value)}
//               >
//                 <option value="internal">Internal</option>
//                 <option value="advance">Advance</option>
//               </select>
//             </div>
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               className="search-input"
//               placeholder="Ask me anything..."
//               disabled={isLoading}
//               aria-label="Search input"
//             />
//             <div>
//               <button
//                 type="submit"
//                 className="search-button"
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Searching..." : "Search"}
//               </button>
//             </div>
//           </form>
//         </div>

//         {isSubmitted && (
//           <div className="response-container" ref={responseContainerRef}>
//             {chatHistory.length === 0 && !isLoading && (
//               <div className="empty-state">No conversation history yet</div>
//             )}
//             {chatHistory.map((chat, index) => (
//               <div key={chat.id} className="chat-item">
//                 <div className="query-display">
//                   <strong>You:</strong> {chat.query}
//                 </div>
//                 <div className="response-display">
//                   <strong>EagleQMS:</strong>{" "}
//                   <div className="response-content">
//                     {parseResponse(chat.responseText, chat.references)}
//                   </div>
//                   {chat.formUrl && (
//                     <div className="form-response">
//                       <a
//                         href={chat.formUrl}
//                         download
//                         className="download-button"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         Download Form
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}
//             {isLoading && (
//               <div className="loading">
//                 <div className="loader"></div>
//                 Analyzing your query...
//               </div>
//             )}
//             <div className="remove-button">
//               <button
//                 onClick={() => {
//                   setChatHistory([]);
//                   localStorage.removeItem("chatHistory");
//                   setIsSubmitted(false);
//                   setQuery("");
//                 }}
//                 className="clear-chat-button"
//               >
//                 Clear Chat History
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchEngine;

// import React, { useState, useEffect, useRef } from "react";
// import "./SearchEngine.css";
// import { toast } from "react-toastify";
// import { useAuth } from "../../context/AuthContext";
// const API_URL = process.env.REACT_APP_API_URL;
// const PYTHON_API_URL = process.env.REACT_APP_PYTHON_BACKEND_URL;

// export const saveQuery = async (query, response, references = []) => {
//   const res = await fetch(`${API_URL}/api/queries/save`, {
//     method: "POST",
//     credentials: "include",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ query, response, references }), // Ensure references are included
//   });

//   return res.json();
// };

// const SearchEngine = () => {
//   const { user } = useAuth();
//   const [query, setQuery] = useState("");
//   const [chatHistory, setChatHistory] = useState([]);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const responseContainerRef = useRef(null);

//   // Auto-scroll to latest response
//   useEffect(() => {
//     if (responseContainerRef.current) {
//       responseContainerRef.current.scrollTo({
//         top: responseContainerRef.current.scrollHeight,
//         behavior: "smooth",
//       });
//     }
//   }, [chatHistory, isLoading]);

//   // Clear storage on page load and before unload
//   useEffect(() => {
//     localStorage.removeItem("chatHistory");

//     const handleBeforeUnload = () => {
//       localStorage.removeItem("chatHistory");
//     };

//     window.addEventListener("beforeunload", handleBeforeUnload);

//     return () => {
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, []);

//   // Load chat history when component mounts
//   useEffect(() => {
//     if (!user?.email) return; // Ensure user is logged in
//     const storedHistory = localStorage.getItem(`chatHistory_${user.email}`);
//     if (storedHistory) {
//       setChatHistory(JSON.parse(storedHistory));
//       setIsSubmitted(true);
//     }
//   }, [user]);

//   // Function to save chat history to localStorage per user
//   const saveChatHistory = (history) => {
//     if (!user?.email) return;
//     localStorage.setItem(`chatHistory_${user.email}`, JSON.stringify(history));
//   };

//   // const parseResponse = (data) => {
//   //   if (!data) return "";

//   //   let text = typeof data === "string" ? data : data.response || "";

//   //   // Convert Markdown-style links [text](URL) → Clickable <a>
//   //   text = text.replace(
//   //     /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
//   //     '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
//   //   );

//   //   // Convert **bold** → <b>bold</b>
//   //   text = text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");

//   //   // Convert *italic* → <i>italic</i>
//   //   text = text.replace(/\*(.*?)\*/g, "<i>$1</i>");

//   //   // Convert newlines to <br> for better readability
//   //   text = text.replace(/\n/g, "<br/>");

//   //   // Convert #-style headings to appropriate HTML tags (e.g., ### → <h3>)
//   //   text = text.replace(
//   //     /^(#{1,6})\s+(.*)$/gm,
//   //     (_, hashes, content) =>
//   //       `<h${hashes.length}>${content}</h${hashes.length}>`
//   //   );

//   //   // Handle references if present
//   //   if (
//   //     data.references &&
//   //     Array.isArray(data.references) &&
//   //     data.references.length > 0
//   //   ) {
//   //     const referencesHtml = data.references
//   //       .map(
//   //         (ref, index) =>
//   //           `<br><a href="${ref.link}" class="refernce-link" target="_blank">${index + 1}. ${
//   //             ref.title
//   //           }</a>`
//   //       )
//   //       .join("");

//   //     text += `<br><br><b>References:</b>${referencesHtml}`;
//   //   }

//   //   return text;
//   // };

//   const parseResponse = (data) => {
//     if (!data) return null;

//     let text = typeof data === "string" ? data : data.response || "";

//     // Convert Markdown-style links [text](URL) → Clickable <a>
//     text = text.replace(
//       /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
//       '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
//     );

//     // Convert **bold** → <b>bold</b>
//     text = text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");

//     // Convert *italic* → <i>italic</i>
//     text = text.replace(/\*(.*?)\*/g, "<i>$1</i>");

//     // Convert #-style headings properly (e.g., ### → <h3>)
//     text = text.replace(
//       /(^|\n)(#{1,6})\s+(.+)/g,
//       (_, prefix, hashes, content) =>
//         `${prefix}<h${hashes.length}>${content}</h${hashes.length}>`
//     );

//     // Convert newlines to <br> for better readability
//     text = text.replace(/\n/g, "<br/>");

//     return (
//       <div>
//         {/* Render parsed response safely */}
//         <div dangerouslySetInnerHTML={{ __html: text }} />

//         {/* Handle References */}
//         {data.references &&
//           Array.isArray(data.references) &&
//           data.references.length > 0 && (
//             <div className="references">
//               <h4>References:</h4>
//               {data.references.map((ref, i) => (
//                 <button
//                   key={`reference-${i}`}
//                   onClick={() => window.open(ref.link, "_blank")}
//                   className="reference-button"
//                 >
//                   {ref.title}
//                 </button>
//               ))}
//             </div>
//           )}
//       </div>
//     );
//   };

//   // Handle search request
//   // const handleSearch = async (e) => {
//   //   e.preventDefault();
//   //   if (!query.trim()) return;

//   //   setIsLoading(true);

//   //   try {
//   //     const response = await fetch("http://localhost:5950/chat", {
//   //       method: "POST",
//   //       headers: { "Content-Type": "application/json" },
//   //       body: JSON.stringify({ message: query }),
//   //     });

//   //     const data = await response.json();

//   //     if (data.response) {
//   //       const formattedResponse = parseResponse(data);

//   //       const newChat = {
//   //         id: Date.now(),
//   //         query,
//   //         response: formattedResponse,
//   //       };

//   //       setChatHistory([...chatHistory, newChat]);
//   //       localStorage.setItem(
//   //         "chatHistory",
//   //         JSON.stringify([...chatHistory, newChat])
//   //       );
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching response:", error);
//   //   }

//   //   setIsLoading(false);
//   //   setQuery("");
//   //   setIsSubmitted(true);
//   // };

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!query.trim()) return;

//     setIsLoading(true);

//     try {
//       const response = await fetch(`${PYTHON_API_URL}/chat`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: query }),
//       });

//       const data = await response.json();

//       if (data.response) {
//         const newChat = {
//           id: Date.now(),
//           query,
//           response: data.response, // Store plain text
//           references: data.references || [], // Store references separately
//         };

//         const updatedChatHistory = [...chatHistory, newChat];
//         setChatHistory(updatedChatHistory);
//         saveChatHistory(updatedChatHistory);
//       }
//     } catch (error) {
//       console.error("Error fetching response:", error);
//     }

//     setIsLoading(false);
//     setQuery("");
//     setIsSubmitted(true);
//   };

//   const handleSaveQuery = async (query, response, references = []) => {
//     try {
//       await saveQuery(query, response, references);
//       toast.success("Query saved successfully!", {
//         position: "top-center",
//         autoClose: 1500,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.error("Error saving query:", error);
//       toast.error("Failed to save query.", {
//         position: "top-center",
//         autoClose: 1500,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };

//   const clearChatHistory = () => {
//     if (!user?.email) return;
//     setChatHistory([]);
//     localStorage.removeItem(`chatHistory_${user.email}`);
//     setIsSubmitted(false);
//     setQuery("");
//   };

//   return (
//     <div className="div-search-engine">
//       <div className="search-engine-container">
//         <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
//           <form onSubmit={handleSearch} className="search-form">
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               className="search-input"
//               placeholder="Ask me anything..."
//               disabled={isLoading}
//               aria-label="Search input"
//             />
//             <div>
//               <button
//                 type="submit"
//                 className="search-button"
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Searching..." : "Search"}
//               </button>
//             </div>
//           </form>
//         </div>

//         {isSubmitted && (
//           <div className="response-container" ref={responseContainerRef}>
//             {chatHistory.length === 0 && !isLoading && (
//               <div className="empty-state">No conversation history yet</div>
//             )}
//             {/* {chatHistory.map((chat) => (
//               <div key={chat.id} className="chat-item">
//                 <div className="query-display">
//                   <strong>You:</strong> {chat.query}
//                 </div>
//                 <div className="query-display">
//                   <strong>CrowsNest:</strong>
//                 </div>
//                 <div
//                   className="response-display"
//                   dangerouslySetInnerHTML={{ __html: chat.response }}
//                 />
//               </div>
//             ))} */}
//             {chatHistory.map((chat) => (
//               <div key={chat.id} className="chat-item">
//                 <div className="query-display">
//                   <strong>You:</strong> {chat.query}
//                 </div>
//                 <div className="query-display">
//                   <strong>CrowsNest:</strong>
//                 </div>
//                 <div className="response-display">
//                   {parseResponse({
//                     response: chat.response,
//                     references: chat.references,
//                   })}
//                 </div>
//                 <div className="save-chat-button">
//                   <button
//                     className="button-37"
//                     onClick={() =>
//                       handleSaveQuery(
//                         chat.query,
//                         chat.response,
//                         chat.references
//                       )
//                     }
//                   >
//                     Save this response
//                   </button>
//                 </div>
//               </div>
//             ))}

//             {isLoading && (
//               <div className="loading">
//                 <div className="loader"></div>
//                 Analyzing your query...
//               </div>
//             )}
//             <div className="remove-button">
//               <button
//                 // onClick={() => {
//                 //   setChatHistory([]);
//                 //   localStorage.removeItem("chatHistory");
//                 //   setIsSubmitted(false);
//                 //   setQuery("");
//                 // }}
//                 onClick={clearChatHistory}
//                 className="clear-chat-button"
//               >
//                 Clear Chat History
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchEngine;

// Latest
import React, { useState, useEffect, useRef } from "react";
import "./SearchEngine.css";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;
const PYTHON_API_URL = process.env.REACT_APP_PYTHON_BACKEND_URL;

export const saveQuery = async (query, response, references = []) => {
  try {
    const res = await fetch(`${API_URL}/api/queries/save`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, response, references }),
    });

    if (!res.ok) {
      throw new Error("Failed to save query");
    }

    const data = await res.json();
    toast.success("Response saved successfully!", {
      position: "top-center",
      autoClose: 1500,
    });
    return data;
  } catch (error) {
    console.error("Error saving query:", error);
    toast.error("Failed to save response", {
      position: "top-center",
      autoClose: 1500,
    });
    throw error;
  }
};

const SearchEngine = () => {
  const { user } = useAuth();
  const [query, setQuery] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const responseContainerRef = useRef(null);

  // Load chat history from localStorage on component mount
  useEffect(() => {
    const savedHistory = localStorage.getItem("chatHistory");
    if (savedHistory) {
      setChatHistory(JSON.parse(savedHistory));
      if (JSON.parse(savedHistory).length > 0) {
        setIsSubmitted(true);
      }
    }
  }, []);

  // Auto-scroll to latest response
  useEffect(() => {
    if (responseContainerRef.current) {
      responseContainerRef.current.scrollTo({
        top: responseContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatHistory, isLoading]);

  // Handle search request
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setIsLoading(true);

    try {
      const response = await fetch(`${PYTHON_API_URL}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: query }),
      });

      const data = await response.json();

      if (data.response) {
        const newChat = {
          id: Date.now(),
          query,
          response: data.response,
          references: data.references || [],
        };

        const updatedChatHistory = [...chatHistory, newChat];
        setChatHistory(updatedChatHistory);
        localStorage.setItem("chatHistory", JSON.stringify(updatedChatHistory));
      }
    } catch (error) {
      console.error("Error fetching response:", error);
      toast.error("Failed to get response", {
        position: "top-center",
        autoClose: 1500,
      });
    }

    setIsLoading(false);
    setQuery("");
    setIsSubmitted(true);
  };

  // Handle saving a query response
  const handleSaveQuery = async (query, response, references) => {
    try {
      await saveQuery(query, response, references);
    } catch (error) {
      console.error("Error in handleSaveQuery:", error);
    }
  };

  // Parse response with Markdown and references
  const parseResponse = (data) => {
    if (!data) return null;

    let text = typeof data === "string" ? data : data.response || "";

    // Convert Markdown-style links [text](URL) → Clickable <a>
    text = text.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Convert **bold** → <b>bold</b>
    text = text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");

    // Convert *italic* → <i>italic</i>
    text = text.replace(/\*(.*?)\*/g, "<i>$1</i>");

    // Convert #-style headings properly (e.g., ### → <h3>)
    text = text.replace(
      /(^|\n)(#{1,6})\s+(.+)/g,
      (_, prefix, hashes, content) =>
        `${prefix}<h${hashes.length}>${content}</h${hashes.length}>`
    );

    // Convert newlines to <br> for better readability
    text = text.replace(/\n/g, "<br/>");

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: text }} />
        {data.references &&
          Array.isArray(data.references) &&
          data.references.length > 0 && (
            <div className="references">
              <h4>References:</h4>
              {data.references.map((ref, i) => (
                <button
                  key={`reference-${i}`}
                  onClick={() => window.open(ref.link, "_blank")}
                  className="reference-button"
                >
                  {ref.title}
                </button>
              ))}
            </div>
          )}
      </div>
    );
  };

  return (
    <div className="div-search-engine">
      <div className="search-engine-container">
        <div className={`header ${isSubmitted ? "slide-up" : ""}`}>
          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="search-input"
              placeholder="Ask me anything..."
              disabled={isLoading}
              aria-label="Search input"
            />
            <button
              type="submit"
              className="search-button"
              disabled={isLoading}
            >
              {isLoading ? "Searching..." : "Search"}
            </button>
          </form>
        </div>

        {isSubmitted && (
          <div className="main-content">
            {/* Left Side: Search Results (70%) */}
            <div className="response-container" ref={responseContainerRef}>
              {chatHistory.length === 0 && !isLoading && (
                <div className="empty-state">No conversation history yet</div>
              )}
              {chatHistory.map((chat) => (
                <div key={chat.id} className="chat-item">
                  <div className="query-display">
                    <span className="query-user">You:</span>{" "}
                    <span className="query-text">{chat.query}</span>
                  </div>
                  <div className="query-display">
                    <span className="query-user">CrowsNest:</span>
                  </div>
                  <div className="response-display">
                    {parseResponse({
                      response: chat.response,
                      references: chat.references,
                    })}
                  </div>
                  <div className="save-chat-button">
                    <button
                      className="button-37"
                      onClick={() =>
                        handleSaveQuery(
                          chat.query,
                          chat.response,
                          chat.references
                        )
                      }
                    >
                      Save this response
                    </button>
                  </div>
                </div>
              ))}
              {isLoading && (
                <div className="loading">
                  <div className="loader"></div>
                  Analyzing your query...
                </div>
              )}
              <div className="remove-button">
                <button
                  onClick={() => {
                    setChatHistory([]);
                    localStorage.removeItem("chatHistory");
                    setIsSubmitted(false);
                    setQuery("");
                  }}
                  className="clear-chat-button"
                >
                  Clear Chat History
                </button>
              </div>
            </div>

            {/* Right Side: Product Cards (30%) */}
            <div className="cards-container">
              <div className="card product-card">
                <h3 className="card-title">Jobs MaritimeGPT</h3>
                <div className="card-content">
                  <p>
                    Find maritime job opportunities with AI-powered matching.
                  </p>
                  <ul className="card-list">
                    <li>Personalized job recommendations</li>
                    <li>Maritime industry expertise</li>
                    <li>Resume optimization</li>
                    <li>Global opportunities</li>
                  </ul>
                  <button
                    className="product-button"
                    onClick={() => window.open("https://jobsmaritimegpt.com")}
                  >
                    Explore Jobs MaritimeGPT
                  </button>
                </div>
              </div>

              <div className="card product-card">
                <h3 className="card-title">Eagle QMS</h3>
                <div className="card-content">
                  <p>Quality Management System for maritime operations.</p>
                  <ul className="card-list">
                    <li>Compliance tracking</li>
                    <li>Document management</li>
                    <li>Audit preparation</li>
                    <li>Performance analytics</li>
                  </ul>
                  <button
                    className="product-button"
                    onClick={() => window.open("https://eagleqms.com")}
                  >
                    Discover Eagle QMS
                  </button>
                </div>
              </div>

              <div className="card product-card">
                <h3 className="card-title">Great Future Tech</h3>
                <div className="card-content">
                  <p>Innovative maritime technology solutions for tomorrow.</p>
                  <ul className="card-list">
                    <li>Advanced navigation systems</li>
                    <li>Fleet management tools</li>
                    <li>Sustainability solutions</li>
                    <li>Digital transformation</li>
                  </ul>
                  <button
                    className="product-button"
                    onClick={() => window.open("https://greatfuture.tech")}
                  >
                    Visit Great Future Tech
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchEngine;
